'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.serialize = serialize;
exports.deserialize = deserialize;

var _omit = require('transmute/omit');

var _omit2 = _interopRequireDefault(_omit);

var _pipe = require('transmute/pipe');

var _pipe2 = _interopRequireDefault(_pipe);

var _messageTypes = require('../pubnub-message/constants/messageTypes');

var _isMessagesUpdateMessage = require('../message-updates/operators/isMessagesUpdateMessage');

var _MessagesUpdates = require('../message-updates/records/MessagesUpdates');

var _MessagesUpdates2 = _interopRequireDefault(_MessagesUpdates);

var _buildPublishedMessage = require('../factories/PubNubMessageFactory/buildPublishedMessage');

var _buildCommentMessage = require('../comment-message-metadata/operators/buildCommentMessage');

var _MessageDescriptorSources = require('../constants/MessageDescriptorSources');

var _commonMessageFormatGetters = require('../common-message-format/operators/commonMessageFormatGetters');

var _pubnubMessageSetters = require('../pubnub-message/operators/pubnubMessageSetters');

var _isThreadComment = require('../pubnub-message/operators/isThreadComment');

var _cmfComparators = require('../common-message-format/operators/cmfComparators');

var _MessageToJson = require('../pubnub-message/operators/MessageToJson');

var _buildCommonMessage = require('../common-message-format/operators/buildCommonMessage');

var _CrmObjectLifecycleUpdate = require('../crm-object-lifecycle-update/records/CrmObjectLifecycleUpdate');

var _CrmObjectLifecycleUpdate2 = _interopRequireDefault(_CrmObjectLifecycleUpdate);

var _isCrmObjectLifecycleUpdate = require('../crm-object-lifecycle-update/operators/isCrmObjectLifecycleUpdate');

var _isContextUpdateMessage = require('../context-update/operators/isContextUpdateMessage');

var _ContextUpdateMessage = require('../context-update/records/ContextUpdateMessage');

var _ContextUpdateMessage2 = _interopRequireDefault(_ContextUpdateMessage);

var _isInitialMessage = require('../initial-message/operators/isInitialMessage');

var _buildInitialMessage = require('../initial-message/operators/buildInitialMessage');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TOP_LEVEL_KEYS = ['client', 'clientTs', 'clientType', 'id', 'senderId', 'threadId', 'timestamp'];

function serialize(message) {
  if ((0, _cmfComparators.isCommonMessageFormat)(message) || (0, _isInitialMessage.isInitialMessage)(message)) {
    return message.toJS();
  }

  switch ((0, _commonMessageFormatGetters.getType)(message)) {
    case _messageTypes.THREAD_COMMENT:
    case _messageTypes.CONTEXT_UPDATE:
      {
        return message.toJS();
      }
    default:
      return (0, _MessageToJson.messageToJson)(message);
  }
}

function constructMessage(_ref) {
  var json = _ref.json,
      factoryFn = _ref.factoryFn;

  return (0, _pipe2.default)(factoryFn, (0, _pubnubMessageSetters.setSource)(_MessageDescriptorSources.MESSAGE_LISTENER))(json);
}

function deserialize(_ref2) {
  var json = _ref2.json,
      _ref2$factoryFn = _ref2.factoryFn,
      factoryFn = _ref2$factoryFn === undefined ? _buildPublishedMessage.buildPublishedMessage : _ref2$factoryFn;

  if ((0, _isMessagesUpdateMessage.isMessagesUpdateMessage)(json)) {
    return new _MessagesUpdates2.default(json);
  }

  if ((0, _isThreadComment.isThreadComment)(json)) {
    return (0, _buildCommentMessage.buildCommentMessage)(json);
  }

  if ((0, _cmfComparators.isCommonMessageFormat)(json)) {
    return (0, _buildCommonMessage.buildCommonMessage)(json);
  }

  if ((0, _isInitialMessage.isInitialMessage)(json)) {
    return (0, _buildInitialMessage.buildInitialMessage)(json);
  }

  if ((0, _isCrmObjectLifecycleUpdate.isCrmObjectLifecycleUpdate)(json)) {
    return new _CrmObjectLifecycleUpdate2.default(json);
  }

  if ((0, _isContextUpdateMessage.isContextUpdateMessage)(json)) {
    return new _ContextUpdateMessage2.default(json);
  }

  if ((0, _commonMessageFormatGetters.getType)(json)) {
    return constructMessage({ json: json, factoryFn: factoryFn });
  }

  // Convert V1 message to V2 to maintain compatibility with older clients
  var metadata = (0, _omit2.default)(TOP_LEVEL_KEYS, json);

  json.metadata = metadata;
  json.metadata.welcomeMessageId = metadata.messageId;
  json.metadata[_messageTypes.MESSAGE_TYPE_ID] = metadata.type;

  return constructMessage({ json: json, factoryFn: factoryFn });
}